export default __webpack_public_path__ + "static/media/avatar.274a7ffa.svg";